//
// Copyright 2025 DXOS.org
//
//# sourceMappingURL=FunctionProtocol.js.map